<template>
  <tab-content
    :title="title"
    :before-change="beforeChange"
  >
    <b-form-group
      :label="label"
      label-align="right"
    />
  </tab-content>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  title: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  beforeChange: {
    type: Function,
    default: () => true,
  },
}

@Component
export default class UpdateQuestion extends Vue.extend({ props }) {}

</script>
